import React, { useState, useEffect } from "react";
import { Row } from "react-bootstrap";
import Layout from "template";
import { MenuItems } from "template/MenuItems";
import { JillaReportCard } from "./JillaReportsCard";
import { JillaSthayiReportCard } from "./ZillaSthayiCard";
import { Link } from "react-router-dom";
import { APIService } from "services";
import {
  useParams
} from "react-router-dom";
export const JillaReport: React.FC = () => {

  const [JillaCount, setJillaCount] = useState([])
  const [jillaSthayiCount, setJillaSthayiCount] = useState([])
  const { id } = useParams();
  // let vibhgId= id
  let vibhagId = localStorage.setItem("vibhag_id", id)
  // console.log("17vibhgIdJilla",vibhagId)

  let vibhagName = localStorage.getItem('vibhag_name')
  // console.log("20vibhgnameJilla",vibhagName)
  const [isLoading, setIsLoading] = React.useState(false);

  useEffect(() => {
    // console.log("15id",type_id)
    setIsLoading(true)
    APIService.api().post("https://lhac.lokahitam.net/api/v1/samithi_members/searchWithFields", { type: "vibhag", type_id: id }).then((response) => {
      console.log("22responsejillascreen", response)
      let vibhagData = response.data.SamithiReport
      let array = []
      array.push(response.data.SamithiReport[0])
      if (array && array.length > 0) {
        const filteredArray = array.filter(item => item !== undefined);
        setIsLoading(false)
        setJillaSthayiCount(filteredArray)
      }
      setJillaCount(vibhagData)
    }).catch((err) => {
      console.log(err)
    })
  }, [1000]);

  let jilla_id = localStorage.getItem("jilla_id")
  // console.log("210nagar_khandaId",nagar_khandaId)
  let vibhag_id = localStorage.getItem("vibhag_id")
  let upamandal_basthi_id = localStorage.getItem("upamandal_basthi_id")
  let MemberName = localStorage.getItem('member_name')
  // let vibhagName=localStorage.getItem('vibhag_name')
  let jillaName = localStorage.getItem('zilla_name')
  let DesignationId = parseInt(localStorage.getItem("desig_level_id"))
  let nagarKhandaName = localStorage.getItem('nagar_khanda_name')
  let upMandalName = localStorage.getItem('upamandal_name')
  let gramamName = localStorage.getItem('gramam_name')
  // console.log("44upMandalNamegramamspage",upMandalName)
  let bastiName = localStorage.getItem('basti_name')
  let nagar_khandaId = localStorage.getItem('nagar_khanda_id')
  return (
    <Layout>
      <div className="container-fluid" >
        <div className="d-sm-flex align-items-center justify-content-between mb-4" >
          {/* <h1 className="h3 mb-0 text-gray-800" > Jillas </h1> */}
        </div>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb" >
            {(DesignationId === 1 || DesignationId === 2) &&
              <li className="breadcrumb-item" ><Link to="/vibhagreports" style={{ color: "#194380" }}>{vibhagName}</Link></li>
            }

          </ol>
        </nav>
        <div className="h5 mb-0 font-weight-bold text-gray-800">
          <p>Namasthe , {MemberName} 🙏</p></div>
        <div className="d-flex flex-column min-vh-100" >

          <Row>
            {jillaSthayiCount.map((item, i) => {
              return <JillaSthayiReportCard key={`Card-${i}`} id={item.id} total_basti_count={item.total_basti_count} total_gramas_count={item.total_gramas_count} total_gramas_formed={item.total_gramas_formed} total_samithi_formed={item.total_samithi_formed} nagar_type={item.nagar_type} zilla_name={item.zilla_name} gramas_formed={item.gramas_formed} samithi_formed={item.samithi_formed} total_basti={item.total_basti} total_gramas={item.total_gramas} />
            })}
          </Row>
          {isLoading ? (
            <div className="d-flex justify-content-center" style={{ marginTop: "230px" }}>
              <div className="spinner-border" role="status">
                <span className="visually-hidden"></span>
              </div>
            </div>
          ) :
            <Row>
              {JillaCount.map((item, i) => {
                return <JillaReportCard key={`Card-${i}`} id={item.id} nagar_type={item.nagar_type} zilla_name={item.zilla_name} gramas_formed={item.gramas_formed} samithi_formed={item.samithi_formed} total_basti={item.total_basti} total_gramas={item.total_gramas} />
              })}
            </Row>
          }
        </div>
      </div></Layout >
  );
};

